module.exports = __webpack_public_path__ + "img/p1-p1-yanzi.bc850a69.png";